import { render } from "./Switchin.vue?vue&type=template&id=66be6da2"
import script from "./Switchin.vue?vue&type=script&lang=js"
export * from "./Switchin.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__